module.exports = __webpack_public_path__ + "img/Spitzwegerich_Trocknungskiste.82609c23.jpg";